"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { faChevronDown, faChevronUp, faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import CircleLoader, { CircleLoaderSize } from "../distribution-plan-tool/common/CircleLoader";
import TransferModal from "./TransferModal";
import { useTransfer } from "./TransferState";
export default function TransferPanel(t0) {
  const $ = _c(58);
  const {
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const t = useTransfer();
  const {
    isConnected
  } = useSeizeConnectContext();
  const {
    enabled,
    setEnabled,
    clear
  } = t;
  const [showModal, setShowModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const previousOverflowRef = useRef("");
  let t2;
  let t3;
  if ($[0] !== clear || $[1] !== enabled || $[2] !== isConnected || $[3] !== setEnabled) {
    t2 = () => {
      if (!isConnected && enabled) {
        setEnabled(false);
        clear();
      }
    };
    t3 = [isConnected, enabled, setEnabled, clear];
    $[0] = clear;
    $[1] = enabled;
    $[2] = isConnected;
    $[3] = setEnabled;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== isExpanded) {
    t4 = () => {
      if (!isExpanded) {
        return;
      }
      previousOverflowRef.current = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = previousOverflowRef.current;
      };
    };
    t5 = [isExpanded];
    $[6] = isExpanded;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const items = Array.from(t.selected.values());
  let t6;
  bb0: {
    if (isLoading) {
      let t7;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <div className="tw-flex tw-items-center tw-justify-center tw-gap-1"><span>Loading transfer data</span><CircleLoader size={CircleLoaderSize.SMALL} /></div>;
        $[9] = t7;
      } else {
        t7 = $[9];
      }
      t6 = t7;
      break bb0;
    }
    if (items.length === 0) {
      let t7;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <>Select some NFTs to transfer</>;
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      t6 = t7;
      break bb0;
    }
    t6 = null;
  }
  const centerMessage = t6;
  let t7;
  if ($[11] !== isExpanded || $[12] !== items) {
    t7 = [items.length, isExpanded];
    $[11] = isExpanded;
    $[12] = items;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  useEffect(() => {
    if (isExpanded && items.length === 0) {
      setIsExpanded(false);
    }
  }, t7);
  let t8;
  let t9;
  if ($[14] !== isExpanded) {
    t8 = () => {
      const handleEscape = e => {
        if (e.key === "Escape" && isExpanded) {
          setIsExpanded(false);
        }
      };
      if (isExpanded) {
        globalThis.addEventListener("keydown", handleEscape);
        return () => globalThis.removeEventListener("keydown", handleEscape);
      }
    };
    t9 = [isExpanded];
    $[14] = isExpanded;
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  useEffect(t8, t9);
  if (!t.enabled) {
    return null;
  }
  let t10;
  if ($[17] !== isExpanded) {
    t10 = isExpanded && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: "easeOut"
    }} className="tw-fixed tw-inset-0 tw-bg-black/50 tw-backdrop-blur-sm tw-z-40" onClick={() => setIsExpanded(false)} aria-hidden="true" />;
    $[17] = isExpanded;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <AnimatePresence>{t10}</AnimatePresence>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["tw-sticky tw-z-50 tw-mt-5 tw-bottom-0", "-tw-mx-2 lg:-tw-mx-6 xl:-tw-mx-8", "tw-w-[calc(100%+theme(space.4))] lg:tw-w-[calc(100%+theme(space.12))] xl:tw-w-[calc(100%+theme(space.16))]", "tw-animate-slideUp"].filter(Boolean);
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = t12.join(" ");
  const t14 = !isExpanded && items.length > 0 && !isLoading ? {
    role: "button",
    tabIndex: 0,
    "aria-label": "Expand transfer panel",
    onClick: e_0 => {
      e_0.stopPropagation();
      const target = e_0.target as HTMLElement;
      if (!target.closest("button")) {
        setIsExpanded(true);
      }
    },
    onKeyDown: e_1 => {
      if (e_1.key === "Enter" || e_1.key === " ") {
        e_1.preventDefault();
        e_1.stopPropagation();
        const target_0 = e_1.target as HTMLElement;
        if (!target_0.closest("button")) {
          setIsExpanded(true);
        }
      }
    }
  } : {
    onClick: _temp
  };
  const t15 = !isExpanded && items.length > 0 && !isLoading && "tw-cursor-pointer";
  let t16;
  if ($[22] !== t15) {
    t16 = ["tw-border-solid tw-border-[#37373ee6] tw-border-l-0", "tw-bg-black tw-text-iron-50", "tw-select-none tw-flex tw-flex-col", t15].filter(Boolean);
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const t17 = t16.join(" ");
  const t18 = items.length > 0 && <button type="button" onClick={() => setIsExpanded(!isExpanded)} disabled={isLoading} className="tw-inline-flex tw-items-center tw-justify-center tw-h-9 tw-w-9 tw-rounded-full tw-bg-white hover:tw-bg-white/90 tw-text-black tw-transition-colors tw-shrink-0 tw-border-[#444] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed" aria-label={isExpanded ? "Collapse panel" : "Expand panel"}><FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronUp} className="tw-size-4" /></button>;
  const t19 = items.length > 0 && <div className="tw-flex tw-items-center tw-overflow-hidden">{items.map((it, index) => <div key={it.key} className="tw-relative tw-flex-shrink-0" style={{
      marginLeft: index > 0 ? "-12px" : "0",
      zIndex: items.length - index
    }}><div className="tw-relative tw-h-10 tw-w-10 tw-rounded-lg tw-overflow-hidden tw-border-2 tw-border-solid tw-border-[#444] tw-bg-white/10">{it.thumbUrl ? <Image alt={it.title ?? it.key} src={it.thumbUrl} fill={true} sizes="40px" className="tw-object-cover" quality={90} /> : <div className="tw-h-full tw-w-full tw-bg-white/10" />}</div></div>)}</div>;
  let t20;
  if ($[24] !== centerMessage) {
    t20 = centerMessage ? <div className="tw-flex-1 tw-text-sm tw-font-medium tw-text-center">{centerMessage}</div> : null;
    $[24] = centerMessage;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  const t21 = centerMessage ? "tw-flex tw-items-center tw-gap-3" : "tw-ml-auto tw-flex tw-items-center tw-gap-3";
  const t22 = items.length > 0 && <div className="tw-text-sm tw-font-medium tw-text-white tw-bg-primary-500 tw-px-4 tw-py-1.5 tw-rounded-full tw-whitespace-nowrap">{t.totalQty} {t.totalQty === 1 ? "item" : "items"}</div>;
  let t23;
  if ($[26] !== t) {
    t23 = () => {
      t.setEnabled(false);
      t.clear();
    };
    $[26] = t;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  let t24;
  if ($[28] !== isLoading || $[29] !== t23) {
    t24 = <button type="button" onClick={t23} disabled={isLoading} className="tw-rounded-lg tw-bg-white/10 hover:tw-bg-white/20 tw-text-white tw-border-2 tw-border-solid tw-border-[#444] tw-transition-colors tw-shrink-0 tw-flex tw-items-center tw-justify-center disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-py-2 tw-px-4 tw-text-sm tw-font-medium tw-min-w-[100px]" aria-label="Cancel">Cancel</button>;
    $[28] = isLoading;
    $[29] = t23;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  const t25 = items.length > 0 && <button type="button" onClick={() => setShowModal(true)} className="tw-rounded-lg tw-bg-white tw-text-black hover:tw-bg-white/90 tw-transition-colors tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-py-2 tw-px-4 tw-text-sm tw-font-medium tw-min-w-[100px]" aria-label="Continue">Continue</button>;
  let t26;
  if ($[31] !== t21 || $[32] !== t22 || $[33] !== t24 || $[34] !== t25) {
    t26 = <div className={t21}>{t22}{t24}{t25}</div>;
    $[31] = t21;
    $[32] = t22;
    $[33] = t24;
    $[34] = t25;
    $[35] = t26;
  } else {
    t26 = $[35];
  }
  let t27;
  if ($[36] !== t18 || $[37] !== t19 || $[38] !== t20 || $[39] !== t26) {
    t27 = <div className="tw-px-4 tw-py-4 tw-flex tw-items-center tw-gap-3">{t18}{t19}{t20}{t26}</div>;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
    $[39] = t26;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  const T0 = AnimatePresence;
  const t28 = isExpanded && items.length > 0 && <motion.div initial={{
    height: 0
  }} animate={{
    height: "auto"
  }} exit={{
    height: 0
  }} transition={{
    duration: 0.3,
    ease: "easeOut"
  }} className="tw-overflow-hidden"><div className="tw-max-h-[40vh] tw-overflow-auto tw-px-4 tw-pb-4"><ul className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 tw-p-0">{items.map(it_0 => {
          const max = Math.max(1, it_0.max ?? 1);
          const qty = Math.min(Math.max(1, it_0.qty ?? 1), max);
          const [collection, tokenId] = it_0.key.split(":");
          const label = `${collection} #${tokenId}`;
          return <li key={it_0.key} className="tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-white/10 tw-bg-white/10 tw-p-2">{it_0.thumbUrl ? <div className="tw-relative tw-h-10 tw-w-10 tw-rounded-md tw-overflow-hidden tw-bg-white/10 tw-shrink-0"><Image alt={it_0.title ?? it_0.key} src={it_0.thumbUrl} fill={true} sizes="40px" className="tw-object-contain" quality={90} /></div> : <div className="tw-h-10 tw-w-10 tw-rounded-md tw-bg-white/10 tw-shrink-0" />}<div className="tw-min-w-0 tw-flex-1"><div className="tw-truncate tw-text-xs">{it_0.title ?? label}</div><div className="tw-truncate tw-text-[10px] tw-opacity-75">{label}</div></div>{max > 1 && <div className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-bg-primary-500 tw-rounded-full tw-p-1 tw-font-medium"><button type="button" onClick={() => t.decQty(it_0.key)} disabled={qty <= 1} aria-label="Decrease quantity" className="tw-bg-transparent tw-border-none tw-p-0 focus:tw-outline-none tw-flex tw-items-center tw-justify-center"><FontAwesomeIcon icon={faMinusCircle} className="tw-size-6 tw-cursor-pointer" color={qty <= 1 ? "#aaa" : "#fff"} /></button><div className="tw-min-w-[2ch] tw-text-center tw-text-sm tw-tabular-nums tw-select-none">{qty}/{max}</div><button type="button" onClick={() => t.incQty(it_0.key)} disabled={qty >= max} aria-label="Increase quantity" className="tw-bg-transparent tw-border-none tw-p-0 focus:tw-outline-none tw-flex tw-items-center tw-justify-center"><FontAwesomeIcon icon={faPlusCircle} className="tw-size-6 tw-cursor-pointer" color={qty >= max ? "#aaa" : "#fff"} /></button></div>}<button type="button" className="tw-inline-flex tw-items-center tw-justify-center tw-h-6 tw-w-6 tw-rounded-full tw-bg-[#ef4444] tw-font-medium tw-text-white hover:tw-bg-[#d92b2b] tw-text-lg tw-p-0 tw-border-0 tw-shrink-0" onClick={() => t.unselect(it_0.key)} aria-label="Remove">×</button></li>;
        })}</ul></div></motion.div>;
  let t29;
  if ($[41] !== T0 || $[42] !== t28) {
    t29 = <T0>{t28}</T0>;
    $[41] = T0;
    $[42] = t28;
    $[43] = t29;
  } else {
    t29 = $[43];
  }
  let t30;
  if ($[44] !== t14 || $[45] !== t17 || $[46] !== t27 || $[47] !== t29) {
    t30 = <div className={t13}><div {...t14} className={t17}>{t27}{t29}</div></div>;
    $[44] = t14;
    $[45] = t17;
    $[46] = t27;
    $[47] = t29;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  let t31;
  if ($[49] !== t) {
    t31 = opts => {
      setShowModal(false);
      if (opts?.completed) {
        t.clear();
        t.setEnabled(false);
      }
    };
    $[49] = t;
    $[50] = t31;
  } else {
    t31 = $[50];
  }
  let t32;
  if ($[51] !== showModal || $[52] !== t31) {
    t32 = <TransferModal open={showModal} onClose={t31} />;
    $[51] = showModal;
    $[52] = t31;
    $[53] = t32;
  } else {
    t32 = $[53];
  }
  let t33;
  if ($[54] !== t11 || $[55] !== t30 || $[56] !== t32) {
    t33 = <>{t11}{t30}{t32}</>;
    $[54] = t11;
    $[55] = t30;
    $[56] = t32;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  return t33;
}
function _temp(e_2) {
  e_2.stopPropagation();
}